import {
  SET_FLOW_METHOD_RESPONSE,
  CACHE_FLOW_METHOD,
  CLEAR_FLOW_METHOD_CACHE,
  CACHE_USER_FIELD
} from '../types';

export const setFlowMethodResponse = (data) => ({
  type: SET_FLOW_METHOD_RESPONSE,
  payload: data
});

export const cacheFlowMethod = (id, data) => ({
  type: CACHE_FLOW_METHOD,
  payload: { id, data }
});

export const clearFlowMethodCache = () => ({
  type: CLEAR_FLOW_METHOD_CACHE
});

export const cacheUserField = (id, data) => ({
  type: CACHE_USER_FIELD,
  payload: { id, data }
});
